export default __webpack_public_path__ + "static/media/waist_pants.68063430.svg";